import React from 'react';
import * as R from 'ramda';

import Button from 'js/components/button';
import GuidelinesChecklist from 'js/components/guidelines_checklist';
import WorkflowPanel from 'js/components/workflow_panel';

import 'scss/icons.scss';
import './index.scss';

export default function MissedGuidelinesApproveOrReject({
    guidelines,
    onApprove,
    onReject,
    isTransmitting
}) {
    const sortedGuidelines = R.sortBy(R.complement(R.prop('should')), guidelines);
    const buttons = [
        <Button
            primary
            key="approve"
            className="missed-guidelines-approve-or-reject__button"
            onClick={onApprove}
            disabled={isTransmitting}
        >
            Approve To Post
        </Button>,
        <Button
            danger
            key="deny"
            className="missed-guidelines-approve-or-reject__button"
            onClick={onReject}
            disabled={isTransmitting}
        >
            Deny
        </Button>
    ];
    return (
        <WorkflowPanel className="missed-guidelines-approve-or-reject" buttons={buttons}>
            <div className="missed-guidelines-approve-or-reject__icon icon-clipboard" />
            <div className="missed-guidelines-approve-or-reject__heading">
                All Missed Guidelines displayed below
            </div>
            <div className="missed-guidelines-approve-or-reject__subheading">
                Please approve or deny this content
            </div>
            <div className="missed-guidelines-approve-or-reject__guidelines">
                <GuidelinesChecklist guidelines={sortedGuidelines} />
            </div>
        </WorkflowPanel>
    );
}



// WEBPACK FOOTER //
// ./components/missed_guidelines_approve_or_reject/index.js